import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/messaging';

let _firebase = null;
let _auth = null;
let _messaging = null;
try {
  firebase.initializeApp({
    apiKey: process.env?.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env?.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env?.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env?.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env?.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env?.REACT_APP_FIREBASE_APP_ID,
  });
  _firebase = firebase?.firestore() || null;
  _auth = firebase?.auth() || null;
  if ('Notification' in window && 'serviceWorker' in navigator) {
    _messaging = firebase?.messaging() || null;
  }
} catch (error) {}

export const firestoreFirebaseApp = _firebase;
export const firestoreFirebaseAuthApp = _auth;
export const firebaseMessaging = _messaging;
